module.exports = __webpack_public_path__ + "static/media/uy.adbc4992.svg";